<template>
  <div>
    <v-head></v-head>
    <div class="more_bg">
      <img src="../assets/pic02.png" alt="">
      <div class="more_txt">
        <div class="title">
          物联网
        </div>
        <div class="txt">
          Internet of Things
        </div>
      </div>
    </div>
    <div class="more_content">
      <div class="more_left">
        <img src="../assets/pic12.png" alt="">
      </div>
      <div class="more_right">
        <div class="maxTitle">基于物联网的设备管理平台</div>
        <div class="more_wrap">
          <div class="title">产品介绍</div>
          <div class="txt">
            移动互联网与物联网技术融合运用，为设备提供完整的生命周期监测与管理，实现精细化管理、达
            到资产安全收益最大化。此外系统强大的兼容性，使其可与项目原有系统完美对接，有效提升设备
            安全管控，降低项目运营风险。
          </div>
          <div class="title">相关案例</div>
          <img src='../assets/pic11.png' alt="" @click="gotoDetail">
          <div class="txt last">基于物联网的设备管理平台</div>
        </div>
      </div>
    </div>
    <div class="more_detail">
      <div class="title_wrap">
        <div class="title">
          产品详情
        </div>
        <div class="mini_title">
          DETAILS
        </div>
      </div>
      <div class="box">
        <div class="more_top">
          <div class="more_list">
            <div class="title">设备运行动态监控 故障自动报警</div>
            <div class="en">Dynamic monitoring of equipment operation Automatic fault alarm</div>
            <div class="txt"><span class="el-icon-caret-right"></span>精准采集设备日常运行数据，动态记录设备运行状
              态，实现高效的设备运行管理机制。设有故障自动
              报警功能，有助于设备资产风险管控，建立完整的
              物联网生态管理体系。</div>
          </div> 
          <div class="more_list">
            <div class="title">设备维保实时记录</div>
            <div class="en">Real-time records of equipment maintenance</div>
            <div class="txt"><span class="el-icon-caret-right"></span>动态记录设备的维修，巡视，保养过程，更便于管
              理人员对该设备状态进行判断，设备自动检测功能，
              发现故障迅速报警，大幅节省人力检测投入成本。</div>
          </div>
          <div class="more_list end">
            <div class="title">设备台账在线管理 紧急预案提前设置</div>
            <div class="en">Online management of equipment ledgers Emergency plans set up in advance</div>
            <div class="txt"><span class="el-icon-caret-right"></span>建立设备台账以便对设备资产管理，设置告警值，
              及时发现异常数据进行报警提醒，并执行紧急预
              案。</div>
          </div>
          
        </div>
        <div class="more_bottom">
          <div class="more_list">
            <div class="title">数据智能化管理 可视直观高效分析</div>
            <div class="en">Intelligent data management Visual and intuitive efficient analysis</div>
            <div class="txt"><span class="el-icon-caret-right"></span>通过项目系统数据库，逐一呈现实施监管项目运营
              状况、生成分析图表，提供全面、高效、完整的评
              估依据，助力计划的制定。</div>
          </div> 
        </div>
      </div>
    </div>
    <div class="more_down">
      <div class="title_wrap">
        <div class="title">
          相关下载
        </div>
        <div class="mini_title">
          DOWNLOAD
        </div>
      </div>
      <div>
        <img src="../assets/code.png" alt="">
      </div>
    </div>
    <v-foot class="more_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    },
    gotoDetail() {
      router.push('/detail5')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.more_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.more_txt {
  position: absolute;
  top: 260px;
  right: 420px;
  color: #fff ;
}
.more_txt .title {
  font-size: 58px;
}
.more_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.more_text {
  display: flex;
}

.more_content {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 70%;
  align-items: center;
  margin: 0 auto;
  padding-top: 80px;
}
.more_left img{
  width: 420px;
  height: 360px;
}
.more_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 50px;
}
.more_right .maxTitle {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}
.more_right .title {
  margin: 15px 0;
  font-size: 22px;
  color: #333;
  font-weight: 600;
}
.more_right .txt {
  font-size: 15px;
  color: #333;
}
.more_right img {
  width: 250px;
  height: 120px;
}
.more_wrap {
  width: 550px;
  border-top: 1px solid #333;
  margin: 15px 0;
}
.more_wrap .last {
  margin-top: 10px;
}
.more_detail {
  width: 1000px;
  margin: 0 auto;
}
.more_detail .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
}
.more_detail .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_detail .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_detail .more_top {
  display: flex;
}
.more_top .more_list {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 300px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px 10px;
}
.more_detail .end {
  margin-right: 0;
}
.more_detail .more_list .title {
  font-size: 18px;
  font-weight: 600;
}
.more_detail .more_list .en {
  font-size: 14px;
  padding: 10px 0;
  color: #bbb;
}
.more_detail .more_list .txt {
  font-size: 14px;
  color: #333;
  display: flex;
}
.el-icon-caret-right {
  margin-top: 5px;
  color: #333;
}
.more_detail .more_bottom {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 280px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  padding: 30px 10px;


}
.more_down {
  width: 1000px;
  margin: 0 auto;
}
.more_down .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
  margin-top: 60px;
}
.more_down .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_down .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/MoreInfor4.vue